import { Form, FormGroup } from "react-bootstrap";
import FormLayout from "../../../../components/Layout/FormLayout";
import ReactInput from "../../../../components/Inputs/ReactInput";
import InputLable from "../../../../components/Inputs/InputLable";
import ReactCheckbox from "../../../../components/Inputs/ReactCheckBox";

const CounterFormContainer = ({ editData, apiHandler }) => {
  const intialValues = {
    name: editData?.name || "",
    isOnBreak: editData?.isOnBreak || false,
    info: editData?.info || "",
    status: editData ? editData?.status : true,
  };

  return (
    <div>
      <FormLayout
        initialValues={intialValues}
        apiHandler={(val) => (apiHandler ? apiHandler(val) : null)}
      >
        <FormGroup>
          <InputLable title="Name" htmlFor="name" required />
          <ReactInput name="name" id="name" required />
        </FormGroup>

        <FormGroup className="mt-3">
          <InputLable title="Info" htmlFor="info" />
          <ReactInput name="info" id="info" />
        </FormGroup>

        {/* Flex container for checkboxes */}
        <div className="d-flex justify-content-end mt-3">
          <div className="">
            <FormGroup className="mt-3">
              <ReactCheckbox label="On Break" name="isOnBreak" id="isOnBreak" />
            </FormGroup>

            <FormGroup className="mt-3">
              <ReactCheckbox label="Active" name="status" id="status" />
            </FormGroup>
          </div>
        </div>
      </FormLayout>
    </div>
  );
};

export default CounterFormContainer;
